export default __webpack_public_path__ + "static/media/fix.322e4ecb.svg";